import { render, staticRenderFns } from "./ReisekostenRechner.vue?vue&type=template&id=2d54b191&scoped=true&"
import script from "./ReisekostenRechner.vue?vue&type=script&lang=js&"
export * from "./ReisekostenRechner.vue?vue&type=script&lang=js&"
import style0 from "./ReisekostenRechner.vue?vue&type=style&index=0&id=2d54b191&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d54b191",
  null
  
)

export default component.exports